<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'orders' | translate}}</h3>
        <br>
        <small class="text-bold">
          {{ pagination.from }} - {{ pagination.to }} von {{ pagination.total }} {{ 'orders' | translate }}
          {{ 'filter_text' | translate }}
        </small>
      </div>
      <div class="box-controls">
        <div class="btn-group">
          <button
            type="button"
            data-toggle="collapse"
            data-target="#coll1"
            aria-expanded="true"
            aria-controls="coll1"
            class="btn btn-default btn-sm"
          >
            <i class="fa fa-sort mr-5"></i>{{'show_hide_filters' | translate}}
          </button>
        </div>
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
        <div class="row">
          <div class="col-xs-12">
            <div class="margin"></div>
            <div id="coll2" class="collapse in" aria-expanded="true" style="">
              <table class="table no-margin">
                <tbody>
                  <tr>
                    <td style="width:auto">1.</td>
                    <td style="width:auto">{{'open-orders' | translate}}</td>
                    <td style="width:70%">
                      <div class="progress progress-sm">
                        <div
                          v-if="open + initials !== 0"
                          class="progress-bar progress-bar-info"
                          :style="`width: ${open * 100/(open + initials)}%`"
                        >
                        </div>
                        <div v-else class="progress-bar progress-bar-info" style="width: 0%"></div>
                      </div>
                    </td>
                    <td><span class="badge bg-info">{{open}}</span></td>
                  </tr>
                  <tr>
                  <td>2.</td>
                  <td>{{'reserved_orders' | translate}}</td>
                  <td>
                    <div class="progress progress-sm">
                      <div
                        v-if="open + initials !== 0"
                        class="progress-bar progress-bar-primary"
                        :style="`width: ${initials * 100/(open + initials)}%`"
                      >
                      </div>
                      <div class="progress-bar progress-bar-primary" style="width: 0%"></div>
                    </div>
                  </td>
                  <td><span class="badge bg-primary">{{initials}}</span></td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="collapse in" id="coll1">
              <div class="pt-10 row">
                <div class="col-md-6 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{`${selectedFilterLabel}_filter` | translate}}
                    </div>
                    <select
                      :class="['form-control', selectedSplitStatus == 'all-all' ? '' : 'focused']"
                      v-model="selectedSplitStatus"
                      @change.prevent="paginate('status')"
                    >
                      <optgroup
                        class="normal"
                        v-for="(group, name) in $store.getters.orderStatusFilters"
                        :label="`${name}_filter` | translate"
                      >
                        <option class="normal" v-for="option in group" :value="`${name}-${option}`">
                          {{`${name}_${option}_filter` | translate}}
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div class="col-md-6 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'period' | translate}}
                    </div>
                    <date-range-picker
                      :class="['form-control', endRange === '' ? '' : 'focused']"
                      :startDate="startRange"
                      :endDate="endRange"
                      id="ordertime"
                      @pepe="onDateRangeChanged"
                    >
                    </date-range-picker>
                  </div>
                </div>
              </div>
              <div class="pt-10 pb-10 row">
                <div class="col-md-4 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'external_orders' | translate}}
                    </div>
                    <select
                      :class="['form-control', selectedMerchantExternalOrder === 0 ? '' : 'focused']"
                      v-model="selectedMerchantExternalOrder"
                      @change.prevent="paginate('merchantExternalOrder')"
                    >
                      <option value="0" class="normal">{{'hide_external_orders' | translate}}</option>
                      <option value="1" class="normal">{{'show_external_orders' | translate}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      v-model="selectedQBId"
                      :class="['form-control', selectedQBId === '' ? '' : 'focused']"
                      placeholder="QB ID"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="[loading? 'fa fa-spinner fa-spin' : 'fa fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      v-model="selectedSku"
                      :class="['form-control', selectedSku === '' ? '' : 'focused']"
                      :placeholder="`${$options.filters.translate('order', $store.getters.language)} #`"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pb-10 row">
                <div class="col-md-4 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      v-model="selectedErpArticleId"
                      :class="['form-control', selectedErpArticleId === '' ? '' : 'focused']"
                      placeholder="Händlernummer"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="[loading? 'fa fa-spinner fa-spin' : 'fa fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      v-model="selectedUsername"
                      :class="['form-control', selectedUsername === '' ? '' : 'focused']"
                      :placeholder="'last_name' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="[loading? 'fa fa-spinner fa-spin' : 'fa fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6 pb-10">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      v-model="extOrderId"
                      class="form-control"
                      :placeholder="'order_number_addition' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'sales_channel' | translate}}
                    </div>
                    <select
                      :class="['form-control', selectedChannel === 'all' ? '' : 'focused']"
                      v-model="selectedChannel"
                      @change.prevent="paginate('channel')"
                    >
                      <template v-for="option in $store.getters.orderChannelsFilters">
                        <option :value="option" class="normal">{{option | translate}}</option>
                      </template>
                    </select>
                  </div>
                </div>
              </div>
              <div class="pb-10 row">
                <div class="col-xs-12">
                  <a href="/picklist" class="btn btn-info btn-sm mr-10" target="_blank" rel="opener">
                    <i class="fa fa-list mr-5"></i>{{'picklist_create' | translate}}
                  </a>
                  <b-0btn @click="resetFilters" type="button" class="btn btn btn-sm btn-warning ml-10">
                    <i class="fa fa-undo mr-5"></i>{{'reset_filters' | translate}}
                  </b-0btn>
                </div>
              </div>
            </div>
          </div>
          <div class="text-right">
          </div>
        </div>
      </div>
      <div class="box-body">
        <template v-if="loading">
          <div class="row">
            <div class="col-xs-12 text-center">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </template>
        <template v-else>
          <order-table :orders="pagination.data" @sort="sort($event)"></order-table>
        </template>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
  </section>
</template>
<script>
import DateRangePicker from '../tools/DateRangePicker.vue'
export default {
  name: 'OrdersOverview',
  data () {
    return {
      loading: true,
      alerts: [],
      selectedFilterLabel: window.localStorage.getItem('filterLabel') ? window.localStorage.getItem('filterLabel') : 'open',
      selectedSplitStatus: window.localStorage.getItem('orderSplitStatus') ? window.localStorage.getItem('orderSplitStatus') : 'open-initial',
      selectedStatus: window.localStorage.getItem('orderStatus') ? window.localStorage.getItem('orderStatus') : 'all',
      selectedChannel: window.localStorage.getItem('orderChannel') !== 0 ? window.localStorage.getItem('orderChannel') : 'all',
      selectedSku: window.localStorage.getItem('orderSku') ? window.localStorage.getItem('orderSku') : '',
      selectedQBId: window.localStorage.getItem('orderQBId') ? window.localStorage.getItem('orderQBId') : '',
      selectedUsername: window.localStorage.getItem('orderUsername') ? window.localStorage.getItem('orderUsername') : '',
      selectedStart: window.localStorage.getItem('selectedStart') ? window.localStorage.getItem('selectedStart') : '',
      selectedEnd: window.localStorage.getItem('selectedEnd') ? window.localStorage.getItem('selectedEnd') : '',
      selectedErpArticleId: window.localStorage.getItem('selectedErpArticleId') ? window.localStorage.getItem('selectedErpArticleId') : '',
      selectedMerchantExternalOrder: 0,
      sortType: window.localStorage.getItem('sortType') ? window.localStorage.getItem('sortType') : 'asc',
      dateRange: 'ciao',
      channels: [{label: 'all', val: 0}, {label: 'schuhe.de', val: 1}, {label: 'schuhe.de-ebay', val: 2}, {label: 'schuhe.de-zalando', val: 3}, {label: 'schuhe.de-amazon', val: 4}, {label: 'schuhe.de-spartoo', val: 10}, {label: 'schuhe.de-mirapodo', val: 12}],
      statusArray: ['all', 'open-and-reserved', 'open', 'shipped', 'returned', 'partial_refund_label', 'canceled', 'mp_cancellation', 'reserved', 'customer_cancellation'],
      startRange: window.localStorage.getItem('selectedStart') ? moment(window.localStorage.getItem('selectedStart')) : moment().subtract(1, 'month'),
      endRange: window.localStorage.getItem('selectedEnd') ? moment(window.localStorage.getItem('selectedEnd')) : moment(),
      extOrderId: window.localStorage.getItem('extOrderId') ? window.localStorage.getItem('extOrderId') : '',
      picklist: [],
      products: {},
      channel: 0,
      returns: 0,
      newItems: 0,
      canceled: 0,
      shipped: 0,
      initials: 0,
      open: 0,
      mpCancel: 0,
      customerCancel: 0,
      statuses: [],
      isActive: '',
      sellOnline: '',
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0
      },
      backup: [],
      paginate (type, value) {
        this.loading = true
        let statusValues = this.selectedSplitStatus.split('-')
        this.selectedFilterLabel = statusValues[0]
        let url = '?preflight=kek'
        if (type === 'page') {
          url += '&page='
          if (value === 'previous') {
            url += (this.pagination.current_page - 1)
          }
          if (value === 'next') {
            url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
          } else if (value !== 'next' && value !== 'previous') {
            url += value
          }
        }
        if (type !== 'sort') {
          this.sortType = this.selectedFilterLabel === 'open' ? 'asc' : 'desc'
        }
        url += `&start=${this.selectedStart}&end=${this.selectedEnd}`
        url += `&sort=${this.sortType}`
        url += `&ext_order_id=${this.selectedSku}`
        url += `&sales_channel=${this.selectedChannel === 'all' ? '' : this.selectedChannel}`
        url += `&order_status=${statusValues[0] === 'all' ? '' : statusValues[0]}`
        url += `&order_id=${this.selectedQBId}`
        url += `&erp_article_number=${this.selectedErpArticleId}`
        url += `&merchant_external_order=${this.selectedMerchantExternalOrder}`
        url += `&line_status=${statusValues[1] === 'all' ? '' : statusValues[1]}`
        url += `&customer_name=${this.selectedUsername}`
        url += `&ext_order_id_addition=${this.extOrderId}`

        window.localStorage.setItem('orderChannel', this.selectedChannel)
        window.localStorage.setItem('selectedErpArticleId', this.selectedErpArticleId)
        window.localStorage.setItem('orderStatus', this.selectedStatus)
        window.localStorage.setItem('orderSku', this.selectedSku)
        window.localStorage.setItem('orderQBId', this.selectedQBId)
        window.localStorage.setItem('orderUsername', this.selectedUsername)
        window.localStorage.setItem('sortType', this.sortType)
        window.localStorage.setItem('selectedEnd', this.selectedEnd)
        window.localStorage.setItem('selectedStart', this.selectedStart)
        window.localStorage.setItem('orderSplitStatus', this.selectedSplitStatus)
        window.localStorage.setItem('filterLabel', this.selectedFilterLabel)
        window.localStorage.setItem('extOrderId', this.extOrderId)

        API.get(`/orders${url}`)
          .then(response => {
            this.loading = false
            this.pagination = response.data
            window.localStorage.setItem('orderPage', this.pagination.current_page)
            this.filterStatus()
          })
          .catch(error => {
            if (this.$store.dispatch('checkError', error)) {
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
              this.$store.commit('pushAlert', alert)
            } else this.$router.push('/unauthorized')
          })
      }
    }
  },
  components: {
    dateRangePicker: DateRangePicker
  },
  methods: {
    triggerStatus (status) {
      this.selectedStatus = status
      this.paginate('status')
    },
    getPicklist () {
      API.get('/orders/picklist')
        .then(response => {
          this.picklist = response
        })
    },
    filterOrders (event) {
      let orders = this.backup
      let status = ''
      this.pagination.data = []
      switch (event) {
        case 1:
          status = 'processing'
          break
        case 2:
          status = 'shipped'
          break
        case 3:
          status = 'returned'
          break
        case 4:
          status = 'canceled'
          break
        default:
          this.pagination.data = this.backup
          break
      }
      for (let x in orders) {
        for (let y in orders[x].status) {
          if (orders[x].status[y].label === status && status !== '') {
            this.pagination.data.push(orders[x])
          }
        }
      }
    },
    onDateRangeChanged (picker) {
      this.dateRange = `${picker.startDate} - ${picker.endDate}`
      this.startRange = picker.startDate
      this.endRange = picker.endDate
      this.selectedEnd = this.endRange.format('YYYY-MM-DD')
      this.selectedStart = this.startRange.format('YYYY-MM-DD')
      this.paginate('', '')
    },
    getOrderStatus (status) {
      let statuses = []
      if (status === 'mp_cancellation') {
        statuses.push({label: 'mp_cancellation_status', style: 'label label-danger', icon: 'fa fa-exclamation-triangle'})
      } else {
        if (status === 'cancelled') {
          statuses.push({label: 'cancelled', style: 'label label-danger', icon: 'fa fa-ban'})
        }
        if (status === 'reserved') {
          statuses.push({label: 'reserved', style: 'label label-primary', icon: 'fa fa-bookmark'})
        } else {
          if (status === 'returned') {
            statuses.push({label: 'returned_status', style: 'label label-warning', icon: 'fa fa-reply'})
          }
          if (status === 'fulfilled') {
            statuses.push({label: 'fulfilled', style: 'label label-success', icon: 'fa fa-check'})
          }
          if (status === 'open') {
            statuses.push({label: 'order_status_open', style: 'label label-info', icon: 'fa fa-sign-in'})
          }
        }
      }
      return statuses
    },
    getStatus (status, order) {
      if (order.status === 'mp_cancellation') {
        return {label: 'mp_cancellation_status', style: 'text-danger', icon: 'fa fa-exclamation-triangle mr-5'}
      } else {
        if (status === 'cancelled') {
          return {label: 'cancelled', style: 'text-danger', icon: 'fa fa-ban mr-5'}
        }
        if (order.status === 'reserved') {
          return {label: 'reserved', style: 'text-primary', icon: 'fa fa-bookmark mr-5'}
        } else {
          if (status === 'returned') {
            if (order.return_service_id !== null) {
              return {label: 'fulfilled', style: 'text-success', icon: 'fa fa-sign-in mr-5'}
            }
            return {label: 'returned_status', style: 'text-warning', icon: 'fa fa-reply mr-5'}
          }
          if (status === 'open') {
            return {label: 'open', style: 'text-info', icon: 'fa fa-sign-in mr-5'}
          }
          if (status === 'initial') {
            return {label: 'open', style: 'text-info', icon: 'fa fa-sign-in mr-5'}
          }
          if (status === 'shipped') {
            return {label: 'fulfilled', style: 'text-success', icon: 'fa fa-sign-in mr-5'}
          }
          if (status === 'fulfilled') {
            return {label: 'fulfilled', style: 'text-success', icon: 'fa fa-sign-in mr-5'}
          }
        }
      }
    },
    filterStatus () {
      let orders = this.pagination.data
      let back = []
      for (let x in orders) {
        back = this.getOrderStatus(orders[x].status)
        for (let lineStatus in orders[x].lines) {
          orders[x].lines[lineStatus].status = this.getStatus(orders[x].lines[lineStatus].status, orders[x])
        }
        orders[x].status = back
      }
    },
    sort (value) {
      this.sortType = value
      this.paginate('sort', '')
    },
    resetFilters () {
      this.selectedSplitStatus = 'all-all'
      this.selectedStatus = 'all'
      this.selectedChannel = 'all'
      this.selectedSku = ''
      this.selectedQBId = ''
      this.selectedUsername = ''
      this.selectedErpArticleId = ''
      this.selectedStart = ''
      this.selectedEnd = ''
      this.sortType = 'asc'
      this.startRange = moment().subtract(1, 'month')
      this.endRange = moment()
      this.dateRange = 'ciao'
      this.updateDatepicker = true
      this.extOrderId = ''
      this.selectedMerchantExternalOrder = 0
      this.paginate()
    }
  },
  mounted () {
    this.$nextTick(() => {
      let statusValues = this.selectedSplitStatus.split('-')
      let url = `?page=${window.localStorage.getItem('orderPage')}`
      url += `&start=${this.selectedStart}&end=${this.selectedEnd}`
      url += `&sort=${this.sortType}`
      url += `&ext_order_id=${this.selectedSku}`
      url += `&sales_channel=${this.selectedChannel === 'all' ? '' : this.selectedChannel}`
      url += `&order_status=${statusValues[0] === 'all' ? '' : statusValues[0]}`
      url += `&order_id=${this.selectedQBId}`
      url += `&erp_article_number=${this.selectedErpArticleId}`
      url += `&merchant_external_order=${this.selectedMerchantExternalOrder}`
      url += `&line_status=${statusValues[1] === 'all' ? '' : statusValues[1]}`
      url += `&customer_name=${this.selectedUsername}`

      if (this.$store.dispatch('checkPermissions', 'co_products')) {
        API.get('orders/orderFilters')
          .then(orderFilters => {
            this.$store.commit('updateOrderStatusFilters', orderFilters.data.status)
            this.$store.commit('updateOrderPaymentsFilters', orderFilters.data.payments)
            this.$store.commit('updateOrderChannelsFilters', orderFilters.data.channels)
          })
        API.get('orders/stats')
          .then(response => {
            this.open = response.data.open
            this.returns = response.data.return
            this.newItems = response.data.new
            this.shipped = response.data.shipped
            this.canceled = response.data.canceled
            this.initials = response.data.reserved
            this.mpCancel = response.data.mp_cancellation
          })
        API.get(`/orders${url}`)
          .then(response => {
            this.loading = false
            this.pagination = response.data
            this.backup = response.data.data
            this.filterStatus()
          })
          .catch(error => {
            if (this.$store.dispatch('checkError', error)) {
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
              this.$store.commit('pushAlert', alert)
            } else this.$router.push('/unauthorized')
          })
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>
<style>
  select option.normal {
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4)
  }
  select option.normal {
    background:#202227
  }
</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
  .italic {
    font-style: italic;
    word-wrap: break-word;
  }
  optgroup.normal {
    background:#202227;
    color:#fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/OrdersOverview.vue